import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import Select from 'react-select';
import { sectorOptions, tipoOptions, stageOptions } from "../../utils/ofertasUtils";
import './OfertasFilter.css';

const OfertasFilter = ({ onFilter, onExport, initialFilters, user, isSuperAdmin = {} }) => {

    const isCallAgent = Boolean(user?.is_call_agent);
    const isRestrictedCallAgent = isCallAgent && !isSuperAdmin;
    const lockedStageOption = { value: 9, label: "Solicitud oferta" };

    const getInitialEtapa = () => {
        if (Array.isArray(initialFilters.etapa)) {
            return initialFilters.etapa;
        }
        if (initialFilters.etapa) {
            const val = parseInt(initialFilters.etapa, 10);
            const option = stageOptions.find(o => o.value === val);
            return option ? [option] : [];
        }
        return [];
    };

    const [poliza, setPoliza] = useState(initialFilters.poliza || "");
    const [cliente, setCliente] = useState(initialFilters.cliente || "");
    const [cups, setCups] = useState(initialFilters.cups || "");
    const [nif, setNif] = useState(initialFilters.nif || "");
    const [ofertaFrom, setOfertaFrom] = useState(initialFilters.ofertaFrom || "");
    const [ofertaTo, setOfertaTo] = useState(initialFilters.ofertaTo || "");
    const [sector, setSector] = useState(initialFilters.sector || "");
    const [tipo, setTipo] = useState(initialFilters.tipo || "");
    const [etapa, setEtapa] = useState(getInitialEtapa());
    const [pendienteFirma, setPendienteFirma] = useState(!!initialFilters.pendiente_firma);

    React.useEffect(() => {
        if (isRestrictedCallAgent) {
            setEtapa([lockedStageOption]);
        } else {
            setEtapa(getInitialEtapa());
        }
    }, [isRestrictedCallAgent, initialFilters.etapa]);

    // Sync internal state when initialFilters changes (e.g. restoration from parent)
    React.useEffect(() => {
        setPoliza(initialFilters.poliza || "");
        setCliente(initialFilters.cliente || "");
        setCups(initialFilters.cups || "");
        setNif(initialFilters.nif || "");
        setOfertaFrom(initialFilters.ofertaFrom || "");
        setOfertaTo(initialFilters.ofertaTo || "");
        setSector(initialFilters.sector || "");
        setTipo(initialFilters.tipo || "");
        setEtapa(getInitialEtapa());
        setPendienteFirma(!!initialFilters.pendiente_firma);
    }, [initialFilters]);


    const handleFilter = (e) => {
        e.preventDefault();
        onFilter({ poliza, cliente, cups, nif, sector, tipo, etapa, ofertaFrom, ofertaTo, pendiente_firma: pendienteFirma });
    };

    const handleReset = () => {
        const resetFilters = {
            poliza: "",
            cliente: "",
            nif: "",
            cups: "",
            sector: "",
            tipo: "",
            etapa: isRestrictedCallAgent ? [lockedStageOption] : [],
            ofertaFrom: "",
            ofertaTo: "",
            pendiente_firma: false
        };
        setPoliza("");
        setCliente("");
        setNif("");
        setCups("");
        setSector("");
        setTipo("");
        setEtapa(isRestrictedCallAgent ? [lockedStageOption] : []);
        setOfertaFrom("");
        setOfertaTo("");
        setPendienteFirma(false);
        onFilter(resetFilters);
    };

    const isFormValid = () => {
        return isDateRangeValid(ofertaFrom, ofertaTo);
    }

    const isDateRangeValid = (dateFrom, dateTo) => {
        const isRangeEmpty = (!dateFrom && !dateTo);
        const isRangeValid = (dateFrom && dateTo) ? new Date(dateFrom) <= new Date(dateTo) : isRangeEmpty;

        return (isRangeValid || isRangeEmpty)
    }

    return (
        <div className="detail-card filter-card p-3 pb-2 border-0 shadow-sm rounded-4">
            <Form onSubmit={handleFilter}>
                <Row className="g-3 gy-4">
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Sector</Form.Label>
                            <Form.Select
                                className="form-control rounded-3 border-light shadow-sm bg-light"
                                value={sector}
                                onChange={(e) => setSector(e.target.value)}
                            >
                                {sectorOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Tipo oferta</Form.Label>
                            <Form.Select
                                className="form-control rounded-3 border-light shadow-sm bg-light"
                                value={tipo}
                                onChange={(e) => setTipo(e.target.value)}
                            >
                                {tipoOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Nº Oferta</Form.Label>
                            <Form.Control
                                type="text"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={poliza}
                                onChange={(e) => setPoliza(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Etapa</Form.Label>
                            <Select
                                classNamePrefix="react-select"
                                options={stageOptions}
                                isMulti
                                value={isRestrictedCallAgent ? [lockedStageOption] : etapa}
                                placeholder="Seleccionar..."
                                onChange={(e) => {
                                    if (!isRestrictedCallAgent) {
                                        setEtapa(e);
                                    }
                                }}
                                isDisabled={isRestrictedCallAgent}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderRadius: '0.5rem',
                                        border: '1px solid #f8f9fa',
                                        boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
                                        backgroundColor: '#f8f9fa'
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Fecha desde</Form.Label>
                            <Form.Control
                                type="date"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={ofertaFrom}
                                onChange={(e) => setOfertaFrom(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Fecha hasta</Form.Label>
                            <Form.Control
                                type="date"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={ofertaTo}
                                onChange={(e) => setOfertaTo(e.target.value)}
                            />
                            {!isDateRangeValid(ofertaFrom, ofertaTo) && (
                                <Form.Text className="text-danger small">
                                    Rango inválido.
                                </Form.Text>
                            )}
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Cliente</Form.Label>
                            <Form.Control
                                type="text"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={cliente}
                                onChange={(e) => setCliente(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">CUPS / CIF</Form.Label>
                            <div className="d-flex gap-2">
                                <Form.Control
                                    type="text"
                                    placeholder="CUPS"
                                    className="rounded-3 border-light shadow-sm bg-light"
                                    value={cups}
                                    onChange={(e) => setCups(e.target.value)}
                                />
                                <Form.Control
                                    type="text"
                                    placeholder="CIF"
                                    className="rounded-3 border-light shadow-sm bg-light"
                                    value={nif}
                                    onChange={(e) => setNif(e.target.value)}
                                />
                            </div>
                        </Form.Group>
                    </Col>

                    <Col md={3} className="d-flex align-items-end">
                        <Form.Group className="w-100 ofertas-filter-switch">
                            <Form.Check
                                type="switch"
                                id="ofertas-pendiente-firma"
                                label={<span className="text-muted small fw-bold text-uppercase">Pendiente firma (Signaturit)</span>}
                                checked={pendienteFirma}
                                onChange={(e) => setPendienteFirma(e.target.checked)}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <div className="d-flex justify-content-end align-items-center mt-4 gap-2 border-top pt-3">
                    <Button
                        variant="outline-secondary"
                        className="rounded-pill px-4 fw-bold"
                        onClick={handleReset}
                    >
                        Limpiar filtros
                    </Button>

                    <Button
                        variant="outline-secondary"
                        className="rounded-pill px-4 fw-bold"
                        disabled={!isFormValid()}
                        onClick={onExport}
                    >
                        Exportar
                    </Button>

                    <Button
                        variant="primary"
                        className="rounded-pill px-4 fw-bold shadow-sm"
                        type="submit"
                        disabled={!isFormValid()}>
                        Buscar Ofertas
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default OfertasFilter;
